import { createContext, useContext } from "react";
import type { InitialData } from "./initial-data";

const InitialDataContext = createContext<InitialData>({});

export function InitialDataProvider({
  data,
  children,
}: {
  data?: InitialData;
  children: React.ReactNode;
}) {
  return (
    <InitialDataContext.Provider value={data ?? {}}>
      {children}
    </InitialDataContext.Provider>
  );
}

export function useInitialData(): InitialData {
  return useContext(InitialDataContext);
}
